import Button from "@edaz/edazkit/Button/index";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import { IconType } from "@edaz/edazkit/Icon";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import { Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { translateGeneral } from "utils/localizations";
import type BalanceViewModel from "viewModels/finance/accountingInventory/balance/balanceViewModel";
import FilterView from "views/common/filter";

const BalanceFilters: ViewComponent<BalanceViewModel> = observer(({ vm }) => {
  const customFilterButton = (
    <Button iconLeft={IconType.Search} className="btn-form-height" type="submit" disabled={!vm.isFilterValid}>
      {translateGeneral("search")}
    </Button>
  );

  const customResetButton = vm.hasFilterChanges ? (
    <Button iconLeft={IconType.Cross} variant="outline-danger" className="btn-form-height" type="reset">
      {translateGeneral("resetFilter")}
    </Button>
  ) : (
    <></>
  );

  return (
    <FilterView vm={vm} customFilterButton={customFilterButton} customResetButton={customResetButton}>
      <Form.Group as={Row} lg={12} xl={12}>
        <div className="form-group col-md-3 col-sm-6">
          <Form.Label>{vm.translate("periodFrom")}</Form.Label>
          <AdvancedSelect target={vm} property="fromMonth" items={vm.months} placeholder={translateGeneral("selectFromList")} />
        </div>
        <div className="form-group col-md-3 col-sm-6">
          <Form.Label>{vm.translate("periodTo")}</Form.Label>
          <AdvancedSelect target={vm} property="toMonth" items={vm.months} placeholder={translateGeneral("selectFromList")} />
        </div>
      </Form.Group>
    </FilterView>
  );
});

export default BalanceFilters;
